export default "__VITE_ASSET__BLuf2QtC__"